// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */import { LivenessState } from './LivenessState';
import { NullFilter } from './NullFilter';

export const LivenessFilter = {...LivenessState,...NullFilter,} as const
export type LivenessFilter = typeof LivenessFilter[keyof typeof LivenessFilter];
